import InfoWidget from './InfoWidget';

export default InfoWidget;
